import {MantineThemeOverride} from "@mantine/core";
import {
  activityPeriodStatusAdminCompleteColorPalette,
  activityPeriodStatusAdminReviewedColorPalette,
  activityPeriodStatusOperatorCodedColorPalette,
  activityPeriodStatusOperatorValidatedColorPalette,
  activityPeriodStatusRawColorPalette,
  activityPeriodStatusVendorApprovedColorPalette,
  activityPeriodStatusVendorEnteredColorPalette,
  cargoSubtypeChemicalsColorPalette,
  cargoSubtypeOilColorPalette,
  cargoSubtypeTankColorPalette,
  cargoSubtypeWasteColorPalette,
  cargoSubtypeWaterColorPalette,
  containerAlertHighColorPalette,
  dispatchCanceledColorPalette,
  dispatchCompletedColorPalette,
  dispatchPendingColorPalette,
  dispatchRequestAcceptedColorPalette,
  dispatchRequestCanceledColorPalette,
  dispatchRequestCompletedColorPalette,
  dispatchRequestPendingColorPalette,
  dispatchRequestPickedUpColorPalette,
  dispatchRequestReassignedColorPalette,
  dispatchRequestRejectedColorPalette,
  dispatchRequestStartedColorPalette,
  dispatchRequestUnresovledColorPalette,
  dispatchStartedColorPalette,
  serviceWorkOrangePalette,
  siteCentralColorPalette,
  siteDefaultColorPalette,
  siteDisposalColorPalette,
  sitePondColorPalette,
  siteStagingColorPalette,
  siteYardColorPalette,
  transportCategoryOilColorPalette,
  transportCategoryWaterColorPalette,
  warningHighColorPalette,
  warningLowColorPalette,
  warningMediumColorPalette,
  gpsMarkerColorPalette, refServiceStatusNeedsServiceColorPalette, refServiceStatusBlockedColor,
  refServiceStatusBlockedColorPalette, refServiceStatusInProgressColorPalette, refServiceStatusUnknownColorPalette,
  refServiceStatusTreatedColorPalette, refServiceStatusClearColorPalette, refServiceStatusClosedColorPalette,
  refServiceStatusOpenColorPalette, noticeSeverityDefaultColorPalette, noticeSeverityInfoColorPalette,
  noticeSeverityMajorColorPalette, noticeSeverityCriticalColorPalette,
} from "./colors";

export const otsThemeOverride: MantineThemeOverride = {
  colors: {
    "site-pad": siteCentralColorPalette.asArray(),
    "site-central": siteCentralColorPalette.asArray(),
    "site-pond": sitePondColorPalette.asArray(),
    "site-disposal": siteDisposalColorPalette.asArray(),
    "site-yard": siteYardColorPalette.asArray(),
    "site-staging": siteStagingColorPalette.asArray(),
    "site-default": siteDefaultColorPalette.asArray(),
    "transport-category-water": transportCategoryWaterColorPalette.asArray(),
    "transport-category-oil": transportCategoryOilColorPalette.asArray(),
    "cargo-subtype-water": cargoSubtypeWaterColorPalette.asArray(),
    "cargo-subtype-oil": cargoSubtypeOilColorPalette.asArray(),
    "cargo-subtype-chemicals": cargoSubtypeChemicalsColorPalette.asArray(),
    "cargo-subtype-waste": cargoSubtypeWasteColorPalette.asArray(),
    "cargo-subtype-tank": cargoSubtypeTankColorPalette.asArray(),
    "dispatch-pending": dispatchPendingColorPalette.asArray(),
    "dispatch-started": dispatchStartedColorPalette.asArray(),
    "dispatch-picked-up": dispatchRequestPickedUpColorPalette.asArray(),
    "dispatch-completed": dispatchCompletedColorPalette.asArray(),
    "dispatch-canceled": dispatchCanceledColorPalette.asArray(),
    "dispatch-request-pending": dispatchRequestPendingColorPalette.asArray(),
    "dispatch-request-started": dispatchRequestStartedColorPalette.asArray(),
    "dispatch-request-picked-up": dispatchRequestPickedUpColorPalette.asArray(),
    "dispatch-request-completed": dispatchRequestCompletedColorPalette.asArray(),
    "dispatch-request-accepted": dispatchRequestAcceptedColorPalette.asArray(),
    "dispatch-request-rejected": dispatchRequestRejectedColorPalette.asArray(),
    "dispatch-request-reassigned": dispatchRequestReassignedColorPalette.asArray(),
    "dispatch-request-canceled": dispatchRequestCanceledColorPalette.asArray(),
    "dispatch-request-unresolved": dispatchRequestUnresovledColorPalette.asArray(),
    "activity-period-raw": activityPeriodStatusRawColorPalette.asArray(),
    "activity-period-admin-reviewed": activityPeriodStatusAdminReviewedColorPalette.asArray(),
    "activity-period-vendor-entered": activityPeriodStatusVendorEnteredColorPalette.asArray(),
    "activity-period-admin-complete": activityPeriodStatusAdminCompleteColorPalette.asArray(),
    "activity-period-operator-validated": activityPeriodStatusOperatorValidatedColorPalette.asArray(),
    "activity-period-vendor-approved": activityPeriodStatusVendorApprovedColorPalette.asArray(),
    "activity-period-operator-coded": activityPeriodStatusOperatorCodedColorPalette.asArray(),
    "container-alert-high": containerAlertHighColorPalette.asArray(),
    "gps-marker": gpsMarkerColorPalette.asArray(),
    "service-work": serviceWorkOrangePalette.asArray(),
    "warning": serviceWorkOrangePalette.asArray(),
    "warning-low": warningLowColorPalette.asArray(),
    "warning-medium": warningMediumColorPalette.asArray(),
    "warning-high": warningHighColorPalette.asArray(),
    "ref-service-status-needs-service": refServiceStatusNeedsServiceColorPalette.asArray(),
    "ref-service-status-blocked": refServiceStatusBlockedColorPalette.asArray(),
    "ref-service-status-in-progress": refServiceStatusInProgressColorPalette.asArray(),
    "ref-service-status-unknown": refServiceStatusUnknownColorPalette.asArray(),
    "ref-service-status-treated": refServiceStatusTreatedColorPalette.asArray(),
    "ref-service-status-clear": refServiceStatusClearColorPalette.asArray(),
    "ref-service-status-closed": refServiceStatusClosedColorPalette.asArray(),
    "ref-service-status-open": refServiceStatusOpenColorPalette.asArray(),
    "notice-severity-default": noticeSeverityDefaultColorPalette.asArray(),
    "notice-severity-info": noticeSeverityInfoColorPalette.asArray(),
    "notice-severity-major": noticeSeverityMajorColorPalette.asArray(),
    "notice-severity-critical": noticeSeverityCriticalColorPalette.asArray(),
  }
};
